<template>
  <div :class="item.class" class="construct-visual-group" :style="groupStyle">
    <Renderer :content="item.content || []" :line="line" :page="page" :itemData="itemData" :actionResolver="actionResolver" @action="$emit('action', $event)" />
  </div>
</template>

<script>
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayGroup',
  mixins: [displayMixin],
  components: { Renderer: () => import('./Renderer.vue') },
  computed: {
    groupStyle() {
      return {
        display: 'flex',
        flexDirection: this.item.direction === 'column' ? 'column' : 'row',
        alignItems: this.flexValue(this.item.align || 'center'),
        justifyContent: this.flexValue(this.item.justify || 'start'),
        flexWrap: this.item.wrap === false ? 'nowrap' : 'wrap',
        gap: `${Number(this.item.gap) || 0}px`,
        minWidth: 0,
      }
    },
  },
}
</script>
